import { Card, CardBody, Col, Container, Input, Label, Row } from "reactstrap";
import { SearchTableButton } from "../../utils/Constant";
import Breadcrumbs from "../../CommonElements/Breadcrumbs/Breadcrumbs";
import { useEffect, useState } from "react";
import '../../utils/helper/style.css';
import useCaisseListe, { CardCaisse, SyntheseParSemaineMensuelle, } from "./apiCaisse";

type Caisses = { [key: string]: any }

const Synthese = () => {

    const [selectedYear, setSelectedYear] = useState<number | null>(null);
    const [filterText, setFilterText] = useState("");
    const [filteredItems, setFilteredItems] = useState<Caisses[]>([]);
    const [selectedMonth, setSelectedMonth] = useState<number | null>(null);
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [refresh, setRefresh] = useState(false);
    const caisse = useCaisseListe(refresh) || [];

    // Récupération initiale
    useEffect(() => {
        const savedFilterText = localStorage.getItem("filterText_caisse") || "";
        const savedSelectedMonth = localStorage.getItem("selectedMonth_caisse");
        const savedSelectedYear = localStorage.getItem("selectedYear_caisse");

        setFilterText(savedFilterText);
        setSelectedMonth(savedSelectedMonth ? parseInt(savedSelectedMonth) : null);
        setSelectedYear(savedSelectedYear ? parseInt(savedSelectedYear) : null);
    }, []);

    // Sauvegarde à chaque changement
    useEffect(() => {
        localStorage.setItem("filterText_caisse", filterText);
        localStorage.setItem("selectedMonth_caisse", selectedMonth ? selectedMonth.toString() : "");
        localStorage.setItem("selectedYear_caisse", selectedYear ? selectedYear.toString() : "");
    }, [filterText, selectedMonth, selectedYear]);

    const clearFilters = () => {
        localStorage.removeItem("filterText_caisse");
        localStorage.removeItem("selectedMonth_caisse");
        localStorage.removeItem("selectedYear_caisse");

        setFilterText("");
        setSelectedMonth(null);
        setSelectedYear(null);
    };

    useEffect(() => {
        const filtered = caisse.filter((item) => {
            const date = new Date(item.date_mouvement);
            const matchMonth = selectedMonth ? (date.getMonth() + 1 === selectedMonth) : true;
            const matchYear = selectedYear ? (date.getFullYear() === selectedYear) : true;
            const matchSearch = item.descriptions?.toLowerCase().includes(filterText.toLowerCase()) || false;

            return matchMonth && matchYear && matchSearch;
        });

        setFilteredItems(filtered);
        setTimeout(() => {
            setIsLoading(false);
        }, 2000);
    }, [caisse, filterText, selectedMonth, selectedYear, refresh]);

    const handleMonthChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
        const value = e.target.value;
        setSelectedMonth(value ? parseInt(value) : null);
    };

    return (
        <div className='page-body'>
            {isLoading ? (
                <div className="loading-container">
                    <div className="spinner-container">
                        <div className="spinner"></div>
                        <span className="loading-text">Chargement de la plateforme...</span>
                    </div>
                </div>
            ) : ( 
            <>
                <Breadcrumbs mainTitle="Synthese" parent="Caisse" />
                <Container fluid>

                    <Row>
                        <Col md="12">
                            <CardCaisse value={caisse} />
                        </Col>
                        <Col md="12">
                            {/* <Card>
                                <CardBody>
                                    <Row>
                                        <Col sm="6">
                                            <div className="dataTables_filter d-flex align-items-center">
                                                <Label className="me-2">{SearchTableButton}:</Label>
                                                <Input
                                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => setFilterText(e.target.value)}
                                                    type="search"
                                                    value={filterText}
                                                />
                                            </div>
                                        </Col>
                                        <Col sm="6">
                                            <div className="dataTables_filter d-flex align-items-center">
                                                <Label className="me-2">Filtrer par mois:</Label>
                                                <Input
                                                    name="type"
                                                    value={selectedMonth || ''}
                                                    onChange={handleMonthChange}
                                                    type="select"
                                                    className="form-control"
                                                >
                                                    <option value="">Mois actuel</option>
                                                    <option value="1">Janvier</option>
                                                    <option value="2">Février</option>
                                                    <option value="3">Mars</option>
                                                    <option value="4">Avril</option>
                                                    <option value="5">Mai</option>
                                                    <option value="6">Juin</option>
                                                    <option value="7">Juillet</option>
                                                    <option value="8">Août</option>
                                                    <option value="9">Septembre</option>
                                                    <option value="10">Octobre</option>
                                                    <option value="11">Novembre</option>
                                                    <option value="12">Décembre</option>
                                                </Input>
                                            </div>
                                        </Col>
                                    </Row>
                                </CardBody>
                            </Card> */}
                            <Card>
                                <CardBody>
                                    <Row className="mb-3 items-center">
                                        <Col sm="3">
                                            {/* <Label>Recherche :</Label> */}
                                            <div className="flex items-center gap-2">
                                            <Input
                                                onChange={(e: React.ChangeEvent<HTMLInputElement>) => setFilterText(e.target.value)}
                                                type="search"
                                                placeholder="Recherche..."
                                                value={filterText}
                                            />
                                            </div>
                                        </Col>

                                        <Col sm="3">
                                            {/* <Label>Mois :</Label> */}
                                            <Input
                                            type="select"
                                            value={selectedMonth || ""}
                                            className="form-control"
                                            onChange={(e) => setSelectedMonth(e.target.value ? parseInt(e.target.value) : null)}
                                            >
                                            <option value="">Tous les mois</option>
                                            <option value="1">Janvier</option>
                                            <option value="2">Février</option>
                                            <option value="3">Mars</option>
                                            <option value="4">Avril</option>
                                            <option value="5">Mai</option>
                                            <option value="6">Juin</option>
                                            <option value="7">Juillet</option>
                                            <option value="8">Août</option>
                                            <option value="9">Septembre</option>
                                            <option value="10">Octobre</option>
                                            <option value="11">Novembre</option>
                                            <option value="12">Décembre</option>
                                            </Input>
                                        </Col>

                                        <Col sm="3">
                                            {/* <Label>Année :</Label> */}
                                            <Input
                                            type="select"
                                            value={selectedYear || ""}
                                            className="form-control"
                                            onChange={(e) => setSelectedYear(e.target.value ? parseInt(e.target.value) : null)}
                                            >
                                            <option value="">Toutes les années</option>
                                            {Array.from({ length: 10 }, (_, i) => {
                                                const year = new Date().getFullYear() - i;
                                                return (
                                                <option key={year} value={year}>
                                                    {year}
                                                </option>
                                                );
                                            })}
                                            </Input>
                                        </Col>

                                        <Col sm="3" className="d-flex align-items-end">
                                            <button
                                            className="btn btn-danger w-100"
                                            onClick={clearFilters}
                                            disabled={!filterText && !selectedMonth && !selectedYear}
                                            >
                                            <i className="fa fa-trash me-1" />
                                            Réinitialiser
                                            </button>
                                        </Col>
                                        </Row>
                                    {/* <Row>
                                        <Col sm="6">
                                            <div className="dataTables_filter d-flex align-items-center">
                                                <Label className="me-2">{SearchTableButton}:</Label>
                                                <Input
                                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => setFilterText(e.target.value)}
                                                    type="search"
                                                    value={filterText}
                                                />
                                            </div>
                                        </Col>
                                        <Col sm="6">
                                            <div className="dataTables_filter d-flex align-items-center">
                                                <Label className="me-2">Filtrer par mois:</Label>
                                                <Input
                                                    name="type"
                                                    value={selectedMonth || ''}
                                                    onChange={handleMonthChange}
                                                    type="select"
                                                    className="form-control"
                                                >
                                                    <option value="">Mois actuel</option>
                                                    <option value="1">Janvier</option>
                                                    <option value="2">Février</option>
                                                    <option value="3">Mars</option>
                                                    <option value="4">Avril</option>
                                                    <option value="5">Mai</option>
                                                    <option value="6">Juin</option>
                                                    <option value="7">Juillet</option>
                                                    <option value="8">Août</option>
                                                    <option value="9">Septembre</option>
                                                    <option value="10">Octobre</option>
                                                    <option value="11">Novembre</option>
                                                    <option value="12">Décembre</option>
                                                </Input>
                                            </div>
                                        </Col>
                                    </Row> */}
                                </CardBody>
                            </Card>
                            <SyntheseParSemaineMensuelle value={filteredItems} />
                        </Col>
                    </Row>
                </Container>
            </>
            )}
        </div >

    )
}

export default Synthese
